import addNamespace from '../addNamespace';

const CLEAR_CART_MESSAGE = 'CLEAR_CART_MESSAGE';

export default addNamespace({
  CLEAR_CART_MESSAGE
}, 'equipment');
